import React from 'react'
import PropTypes from 'prop-types'
import { Star, Text, Gallery } from '../../tools'

function InovationColumn({ setting }) {
  const {
    module,
    list_index,
    labelEdit = () => {},
    textEdit = () => {},
    hasGallery = false,
  } = setting

  return (
    <>
      {module.map((item, index) => (
        <div className="inovation-card">
          <div className="inner d-flex">
            <div className="column-left">
              <div className="badge rounded-pill bg-white">
                {`方案${index + 1}`}
              </div>
              <div className="flex-1">
                <Text
                  setting={{
                    content: [
                      `<p><strong>${item.headline}</strong></p><p>${item.ideas}</p>`,
                    ],
                    label: list_index,
                    labelEdit,
                    textEdit: (id, non, text) => {
                      // console.log(value)
                      // console.log(v1)
                      // console.log(v2)
                      textEdit(index, 'ideas', text)
                    },
                  }}
                />
              </div>
              <div className="star">
                <Star
                  setting={{
                    star: item.star.length,
                    setstar: (value) =>
                      textEdit(index, 'star', item.star[0].repeat(value)),
                  }}
                />
              </div>
            </div>
            {hasGallery && (
              <div className="column-right">
                <Gallery
                  setting={{
                    imgs: item.images || [],
                  }}
                />
              </div>
            )}
          </div>
        </div>
      ))}
    </>
  )
}

InovationColumn.propTypes = {
  setting: PropTypes.shape().isRequired,
}

export default InovationColumn
